import type { FC } from "react";
import type { SxProps } from "@mui/material";
import Chip, { type ChipProps } from "@mui/material/Chip";
import cx from "classnames";
import { useGetTagSX } from "./Tag.hooks";
import { resolveTagLabel } from "./Tag.utils";

type TagProps = {
  tag: string;
} & Omit<ChipProps, "label" | "variant">;

export const Tag: FC<TagProps> = ({
  tag,
  className,
  sx,
  onClick,
  size = "small",
  ...props
}) => {
  const chipSx = useGetTagSX(!!onClick);
  const mergedSx = [chipSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])] as SxProps;

  return (
    <Chip
      {...props}
      label={resolveTagLabel(tag)}
      size={size}
      variant="outlined"
      onClick={onClick}
      sx={mergedSx}
      className={cx(className, { "text-sm": size === "medium" })}
      data-test-id={"tag--" + tag}
    />
  );
};
